export default "__VITE_ASSET__DYR_yl9D__"